import { LegalAction } from '../model/legalReducer';
import { LegalModel } from '../model/legalModel';

export const legalViewModel = {
  loadContent: async (
    dispatch: React.Dispatch<LegalAction>,
    fetchFunction: () => Promise<LegalModel>,
    errorMessage: string
  ) => {
    dispatch({ type: 'FETCH_START' });

    try {
      const model = await fetchFunction();
      dispatch({ type: 'FETCH_SUCCESS', payload: model });
    } catch {
      dispatch({
        type: 'FETCH_ERROR',
        payload: errorMessage
      });
    }
  }
};
